/**
 * Utility function to expose internal context of a class/composable for testing
 */
export function exposeToTests<T extends object>(privateApi: T): T {
  return process.env.VITEST ? privateApi : {} as T;
}
